var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iq-progress-bar"},[_c('span',{ref:"progress",class:("bg-" + _vm.color),staticStyle:{"transition":"'width 2s ease 0s'"},attrs:{"data-value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }